/**
 * Small text helpers for translated strings (I18N_STRATEGY): `t()` takes no values and has no plurals,
 * so callers fill placeholders and pick the noun for a count here — one home, used by the ops KPI panel
 * and the owner pages.
 */
import { arabicPlural } from './alertDisplay';

/** `{name}` placeholders, the same way the locale files write them. */
export const fill = (template, values) =>
  Object.entries(values).reduce((text, [name, value]) => text.replace(`{${name}}`, value), template);

/** The noun for a count: Arabic has its own rule, English is one or many. forms = { one, two, few }. */
export const nounFor = (count, forms, language) => (
  language === 'ar'
    ? arabicPlural(count, forms.one, forms.two, forms.few)
    : (count === 1 ? forms.one : forms.few)
);

/**
 * A count with its noun in the house wording (I18N_STRATEGY: «ليلة واحدة» · «ليلتان» · «3 ليالٍ» · «11 ليلة»).
 * forms = { one, two, few, many }: `one` and `two` are whole phrases; `few` (3–10) and `many` (0, 11+) follow the
 * number. English uses the same shape ({ one: '1 night', two: '2 nights', few: 'nights', many: 'nights' }).
 * @param {number} count
 * @param {{one: string, two: string, few: string, many: string}} forms
 * @param {(n: number) => string} formatNumber - the page's digits
 */
export const countWith = (count, forms, formatNumber = String) => {
  if (count === 1) return forms.one;
  if (count === 2) return forms.two;
  return `${formatNumber(count)} ${count >= 3 && count <= 10 ? forms.few : forms.many}`;
};

/** Items joined the way the language lists them: «أ، ب» / "a, b". Empty items are dropped. */
export const joinList = (parts, language) => parts.filter(Boolean).join(language === 'ar' ? '، ' : ', ');
